import { RiMoneyDollarCircleFill } from '@react-icons/all-files/ri/RiMoneyDollarCircleFill';
import React from 'react';
export const Dollar = ({ style }) => <RiMoneyDollarCircleFill style={style}/>;
